import { Layers, LineLayerOptions } from '../models';
import { MapLayerRenderer } from '../mapbox-map-layer-renderer';
import { MapboxHelper } from '../mapbox-map-helper';
import { Theme } from 'src/app/modules/shared/models';

export class RenderRouteTilesetLayer extends MapLayerRenderer {
    constructor(
        protected _mapboxHelper: MapboxHelper,
        private _theme: Theme = Theme.Light
    ) {
        super(_mapboxHelper);

    }

    protected modifyFeatureCollection(fc: GeoJSON.FeatureCollection): GeoJSON.FeatureCollection {
        return fc;
    }

    protected renderLayers(map: mapboxgl.Map): void {
        const layers = {};
        layers[Layers.RouteTileset] = [];
        const layerId = `${Layers.RouteTileset}`;

        if (!this._mapboxHelper.layerExists(map, layerId)) {
            let layerNames = [];
            const options = this._shapeOptions();
            layerNames = this._mapboxHelper.renderLineLayer(map, this._sourceId, this._sourceLayer, layerId, options);
            layers[Layers.RouteTileset] = layers[Layers.RouteTileset].concat(layerNames);
        }

        this.addLayerNames(layers);
    }

    private _shapeOptions(): LineLayerOptions {
        const options = new LineLayerOptions();
        options.color = this._theme !== Theme.Light ? '#ffffff' : '#2C2C2C';
        options.visibility = true;

        // zoom levels are built into tileset and not possible to change here.
        // https://docs.mapbox.com/help/troubleshooting/adjust-tileset-zoom-extent/
        options.visibleFrom = 4; // no impact
        options.visibleTo = 22; //  no impact

        options.lineWidth = 1;
        options.opacity = 1;
        options.layerBefore = 'traffic';

        return options;
    }

}

